import { render, staticRenderFns } from "./identity_layer.vue?vue&type=template&id=e9315452"
import script from "./identity_layer.vue?vue&type=script&lang=js"
export * from "./identity_layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports